import { Button, Col, Form, Input, Row, Space, Spin, Switch } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import axiosInstance from '../../../../../../../axios_instance';
import {
  AchievementListContext,
  IsAdminContext,
  NumberOfAchivementsContext,
  UserAchievementsDataContext,
} from '../../../../../../../context';
import { errorHandling } from '../../../../../../../utils/helper';
import { SelectStringInput } from '../../../../../select-input';
import styles from './styles.module.scss';

const StyledSelectStringInput = styled(SelectStringInput)`
  .ant-select-selector {
    background-color: #f6f7fc !important;
    border: none !important;
  }
  border-bottom: 1px solid #d5d5d5;
`;

const AddAchievement: React.FC<{ setAddNew: any }> = ({
  setAddNew,
}: {
  setAddNew: any;
}) => {
  const AchievementListFromContext = useContext(AchievementListContext);
  const [achievementValue, setAchievementValue] = useState<number>();
  const [levelValue, setLevelValue] = useState<number>();
  const [hasCertificate, setHasCertificate] = useState<number | string>();
  const [formData, setFormData] = useState<{ [key: string]: number }>({});
  const { userAchievementsData, setUserAchievementsData } = useContext(
    UserAchievementsDataContext
  );
  const [errorMessage, setErrorMessage] = useState<any>({});
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const isAdmin = useContext(IsAdminContext);
  const [message, setMessage] = useState<string>();
  //This url query parameter will be available for admin user
  const { employeeId } = useParams();
  const { numberOfAchievements, setNumberOfAchievements } = useContext(
    NumberOfAchivementsContext
  );

  const [showInResume, setShowInResume] = useState(true);

  const handleChangeResume = (value: any) => {
    setShowInResume(value);
  };

  const handleSave = (values: any) => {
    setIsSubmitted(true);
    values.show_in_resume = showInResume;
    let url = '';
    if (isAdmin === '1') {
      url = '/api/v1/admin/profile/achievements';
      values.profile_id = employeeId;
    } else {
      url = '/api/v1/profile/achievements';
    }
    axiosInstance
      .post(url, values)
      .then((response) => {
        console.log(response);
        const userAchievements = response.data.achievements.filter(
          (achievement: any) => achievement['status']['id'] === 1
        );
        // const orderedAchievements = response.data.achievements.map((achievementId: number) =>
        //   userAchievements.find((userAchievement: any) => userAchievement.achievement_id === achievementId)
        // ).filter((item: any) => item !== undefined);
        setUserAchievementsData(userAchievements);
        setAddNew(false);
        setNumberOfAchievements(userAchievements.length);
      })
      .catch((error) => {
        console.log(error);
        errorHandling(error, setErrorMessage);
      })
      .finally(() => {
        setIsSubmitted(false);
      });
  };

  useEffect(() => {
    if (
      userAchievementsData &&
      userAchievementsData.find(
        (data: any) => data.achievement_id === achievementValue
      )
    ) {
      setMessage('The Achievement already exists.');
    } else {
      setMessage('');
    }
  }, [achievementValue]);

  return (
    <div>
      <Form onFinish={handleSave} scrollToFirstError>
        <Row
          gutter={24}
          style={{ paddingBottom: '40px' }}
          className={styles.row}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              position: 'absolute',
              bottom: '8px',
              right: '30px',
            }}
          >
            <Switch defaultChecked onChange={handleChangeResume} />
            <span>Show in resume</span>
          </div>
          <Col className="mb-2" span={12}>
            {message && <p style={{ color: 'green' }}>{message}</p>}
            <Form.Item
              name="title"
              className={styles.title}
              labelAlign="left"
              label="Title"
              rules={[
                { required: true, message: 'Please enter Achievement Title' },
              ]}
            >
              <Input placeholder="Enter Achievement Title" />
            </Form.Item>
          </Col>
          <Col className="mb-2" span={12}>
            <Form.Item name="description" label="Description">
              <Input.TextArea rows={3} placeholder="Enter Description" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="url" label="Url">
              <Input placeholder="Enter Achievement Url" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="score" label="Score">
              <Input placeholder="Enter Score" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          {isSubmitted ? <Spin /> : null}
          <Form.Item style={{ marginLeft: 'auto' }}>
            <Space>
              <Button
                className={styles['save-button']}
                type="primary"
                htmlType="submit"
              >
                Save
              </Button>
              <Button
                className={styles['cancel-button']}
                onClick={() => setAddNew(false)}
              >
                Cancel
              </Button>
            </Space>
          </Form.Item>
        </Row>
      </Form>
    </div>
  );
};

export default AddAchievement;
